export const channelInfo = {
  title: "Roots and Branches Adoption Stories",
  description: "Real Stories. Real Voices. Real Healing. Hosted by Janet Munro, this is a gathering place for stories that explore the unseen roots of our identity.",
  image: "https://hosting-media.rs-prod.riverside.fm/media/podcasts/7288ea58-3467-4ffc-b5f0-70c2a9162842/logos/534c2bf3-382e-4966-b354-25d8ddec709e.png",
  link: "https://rootsandbranchesadoptionstories.com/"
};

// Static episodes are now used as a fallback or removed in favor of the live RSS feed
export const episodes = [];